import hasObjectPath from 'utils/objectsValidation/hasObjectPath';

export interface IProductOrder {
	createProductOrder: {
		result: {
			result: {
				errorCode: string;
				errorDescription: string;
				resultCode: string;
				resultDescription: string;
				resultTime: string;
			};
		};
		ResponseHeader: {
			FunctionId: string;
			RequestId: string;
			ReturnCode: string;
			ReturnDesc: string;
			TransactionId: string;
		};
	};
}

export type CreateProductOrderResponse = {
	createProductOrder: IProductOrder;
	success: boolean;
};

export function isEsbSuccess(data: any) {
	const keys = Object.keys(data);
	const mainKey = data[keys[0]];

	if (hasObjectPath(mainKey, 'result', 'resultCode')) {
		return (
			mainKey.result.resultCode === '0' ||
			mainKey.result.resultCode === '1000' ||
			mainKey.result.resultCode === '0001'
		);
	} else if (hasObjectPath(mainKey, 'ReturnCode')) {
		return mainKey.ReturnCode === '0' || mainKey.ReturnCode === '1000' || mainKey.ReturnCode === '0001';
	} else if (hasObjectPath(mainKey, 'returnCode')) {
		return mainKey.returnCode === '0' || mainKey.returnCode === '1000' || mainKey.returnCode === '0001';
	} else {
		return false;
	}
}

const model: types.models.InputModel = {
	createProductOrder: 'response.createProductOrderResponse',
	success: (model: CreateProductOrderResponse) => {
		return isEsbSuccess(model.createProductOrder);
	},
};

export default model;
